<div class="earnings-container">
  <div class="stats-section mb-4">
    <div class="stat-card border" *ngFor="let stat of stats">
      <div class="stat-icon">
        <i class="bi bi-{{stat.icon}}"></i>
      </div>
      <div class="stat-content">
        <h3 class="text-danger">{{stat.value}}</h3>
        <p>{{stat.title}}</p>
      </div>
    </div>
  </div>

  <div class="row g-4">
    <div class="col-lg-8">
      <div class="card h-full">
        <div class="card-header">
          <h5>Earnings Overview</h5>
          <div>
            <button class="btn btn-sm btn-outline-secondary me-2">
              Monthly
            </button>
            <button class="btn btn-sm btn-danger">
              Quarterly
            </button>
          </div>
        </div>
        <div class="card-body">
          <div class="chart-placeholder">
            <i class="fas fa-chart-line"></i>
            <h4>Earnings Performance Chart</h4>
            <p>Visual representation of your earnings over time</p>
          </div>
        </div>
      </div>

      <div class="card h-full">
        <div class="card-header">
          <h5>Recent Transactions</h5>
          <a href="#" class="btn btn-sm btn-outline-danger">View All</a>
        </div>
        <div class="card-body">
          <div class="transaction-item" *ngFor="let transaction of transactions">
            <div class="transaction-icon">
              <i class="fas fa-{{transaction.icon}}"></i>
            </div>
            <div class="transaction-info">
              <h6>{{transaction.product}}</h6>
              <p>{{transaction.date}} • {{transaction.id}}</p>
            </div>
            <div class="transaction-amount" [ngClass]="{
              'text-success': transaction.status === 'paid',
              'text-danger': transaction.status === 'failed',
              'text-warning': transaction.status === 'pending'
            }">
              {{transaction.amount}}
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-lg-4">
      <div class="card">
        <div class="card-header">
          <h5>Payout Methods</h5>
          <button class="btn btn-sm btn-outline-danger">
            <i class="fas fa-plus"></i> Add
          </button>
        </div>
        <div class="card-body">
          <div class="payout-method" *ngFor="let method of payoutMethods">
            <i class="fab fa-{{method.icon}}" *ngIf="method.icon === 'razorPay'"></i>
            <i class="fas fa-{{method.icon}}" *ngIf="method.icon !== 'razorPay'"></i>
            <div>
              <h6 class="mb-1">{{method.name}}</h6>
              <p class="mb-0">{{method.details}}</p>
            </div>
          </div>

          <div class="d-grid mt-4">
            <a href="/associates/kyc">
            <button class="btn btn-danger" >
              <i class="fas fa-rupee-sign me-2"></i>Request Payout
            </button>
            </a>
          </div>
        </div>
      </div>

      <div class="card">
        <div class="card-header">
          <h5>Payout History</h5>
          <a href="#" class="btn btn-sm btn-outline-danger">View All</a>
        </div>
        <div class="card-body">
          <div class="transaction-item" *ngFor="let payout of payoutHistory">
            <div class="transaction-icon text-white" [ngClass]="{
              'bg-success': payout.status === 'paid',
              'bg-warning': payout.status === 'pending',
              'bg-danger': payout.status === 'failed'
            }">
              <i class="fas fa-check" *ngIf="payout.status === 'paid'"></i>
              <i class="fas fa-clock" *ngIf="payout.status === 'pending'"></i>
              <i class="fas fa-times" *ngIf="payout.status === 'failed'"></i>
            </div>
            <div class="transaction-info">
              <h6>{{payout.title}}</h6>
              <p>{{payout.date}} • {{payout.method}}</p>
            </div>
            <div>
              <span class="payout-status" [ngClass]="{
                'status-paid': payout.status === 'paid',
                'status-pending': payout.status === 'pending',
                'status-failed': payout.status === 'failed'
              }">
                {{payout.status | titlecase}}
              </span>
              <div class="transaction-amount" [ngClass]="{
                'text-success': payout.status === 'paid',
                'text-danger': payout.status === 'failed'
              }">
                {{payout.amount}}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
